export const LABEL_CREATED_STATUS = {
  FULL: 'full',
  PARTLY: 'partly',
} as const

export type LabelCreatedStatus = typeof LABEL_CREATED_STATUS[keyof typeof LABEL_CREATED_STATUS]

export interface A1RemovedOrder {
  id: number
  bae_id: string | null
  tracking_number: string | null
  removed_at: string
  removed_by: string | null
  customs_status: string | null
  current_batch: string | null
  current_batch_id: number | null
  is_transferred_to_another_origin_partner: boolean
}
